import type { DeploymentConfig } from './types';

/**
 * Whether the multi-tenant installation wizard is enabled for this deployment.
 *
 * The backend sets `features.mt_wizard_enabled` only for MT profiles (`full` /
 * `single_tenant`, plus dev/ci) and omits it entirely for the rest (e.g.
 * `onprem`) — the response is serialized with `exclude_none=True`. A missing
 * flag therefore means "not an MT wizard deployment", so it defaults to `false`
 * (wizard unrestricted / onprem-like), never `true`.
 */
export const isMtWizardEnabled = (config: DeploymentConfig): boolean =>
  config.features?.mt_wizard_enabled ?? false;

/**
 * Whether this deployment explicitly enables the onboarding wizard.
 */
export const isOnboardingWizardAvailable = (
  config: DeploymentConfig,
): boolean => config.features?.onboarding_wizard_available ?? false;

export const areIntegrationsAvailable = (config: DeploymentConfig): boolean =>
  config.features?.integrations_available ?? true;

export const isBillingAvailable = (config: DeploymentConfig): boolean =>
  config.features?.billing_available ?? true;

export const isOrganizationManagementAvailable = (
  config: DeploymentConfig,
): boolean => config.features?.organization_management_available ?? true;
